"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const NutritionInterface_1 = require("./Nutrition/NutritionInterface");
const asFloat_1 = __importDefault(require("../Util/asFloat"));
const TrainingInterface_1 = require("../BusinessLogicLayer/TrainingInterface");
class CalorieBudgetUtils {
    constructor(dateTimeModifier) {
        this.zeroValueCalorieBudget = {
            calories: 0,
            carbohydrates: 0,
            fats: 0,
            proteins: 0,
            fibers: 0,
        };
        this.countAverageCalorieBudget = (days, budgets) => {
            const assignedBudgetsToDays = days.map(this.assignBudgetToDay(budgets));
            const trainingDaysBudgets = [];
            const nonTrainingDaysBudgets = [];
            assignedBudgetsToDays.forEach((day) => {
                if (day.method === NutritionInterface_1.DayMethod.handpalm)
                    return;
                if (day.dayType === TrainingInterface_1.WeekDayType.TRAINING_DAY) {
                    return trainingDaysBudgets.push(day.calorieBudget.forTrainingDay);
                }
                nonTrainingDaysBudgets.push(day.calorieBudget.forNonTrainingDay);
                return;
            });
            return {
                forTrainingDay: this.getAverageFromCalorieBudgets(trainingDaysBudgets),
                forNonTrainingDay: this.getAverageFromCalorieBudgets(nonTrainingDaysBudgets),
            };
        };
        this.pickCalorieBudget = (calorieBudgets, dateRange) => {
            for (const [key, value] of calorieBudgets.entries()) {
                const [to, from] = key.split("~");
                if (this.dateTimeModifier.dateInDateRange(to, from, dateRange.to)) {
                    return value;
                }
            }
            return Array.from(calorieBudgets.values())[calorieBudgets.size - 1];
        };
        this.pickCalorieBudgetForDate = (calorieBudgets, date) => {
            for (const [key, value] of calorieBudgets.entries()) {
                const [to, from] = key.split("~");
                if (this.dateTimeModifier.dateInDateRange(to, from, date)) {
                    return value;
                }
            }
            return {
                forNonTrainingDay: this.zeroValueCalorieBudget,
                forTrainingDay: this.zeroValueCalorieBudget,
            };
        };
        this.mapCalorieBudgetUnit = (calorieBudget, unit) => {
            if (unit !== "g") {
                return {
                    ...calorieBudget,
                    forNonTrainingDay: this.recalculateCalorieBudgetToOz(calorieBudget.forNonTrainingDay),
                    forTrainingDay: this.recalculateCalorieBudgetToOz(calorieBudget.forTrainingDay),
                };
            }
            return calorieBudget;
        };
        this.recalculateCalorieBudgetToOz = ({ calories, carbohydrates, fats, fibers, proteins, }) => {
            return {
                calories: calories,
                carbohydrates: this.calculateToOz(carbohydrates),
                fats: this.calculateToOz(fats),
                fibers: this.calculateToOz(fibers),
                proteins: this.calculateToOz(proteins),
            };
        };
        this.assignBudgetToDay = (budgets) => (day) => {
            const DayWithDefaultBudget = {
                ...day,
                calorieBudget: {
                    forNonTrainingDay: this.zeroValueCalorieBudget,
                    forTrainingDay: this.zeroValueCalorieBudget,
                },
            };
            for (const [key, value] of budgets.entries()) {
                const [from, to] = key.split("~");
                if (this.dateTimeModifier.dateInDateRange(from, to, DayWithDefaultBudget.date)) {
                    return {
                        ...DayWithDefaultBudget,
                        calorieBudget: value,
                    };
                }
            }
            return DayWithDefaultBudget;
        };
        this.addBudgets = (acc, budget) => ({
            calories: acc.calories + budget.calories,
            proteins: acc.proteins + budget.proteins,
            carbohydrates: acc.carbohydrates + budget.carbohydrates,
            fats: acc.fats + budget.fats,
            fibers: acc.fibers + budget.fibers,
        });
        this.getAverageFromCalorieBudgets = (budgets) => {
            if (!budgets.length)
                return this.zeroValueCalorieBudget;
            const total = budgets.reduce(this.addBudgets, this.zeroValueCalorieBudget);
            const average = {};
            for (const [key, value] of Object.entries(total)) {
                average[key] = Math.round(value / budgets.length);
            }
            return average;
        };
        this.calculateToOz = (value) => (0, asFloat_1.default)(value * 0.03527396195, 2);
        this.dateTimeModifier = dateTimeModifier;
    }
}
exports.default = CalorieBudgetUtils;
//# sourceMappingURL=CalorieBudgetUtils.js.map